import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppDispatch, RootState } from '../store'; // Asegúrate de importar AppDispatch y RootState desde la definición del store

// Definimos el tipo de estado para `modalAlert`
interface ModalAlertState {
  options: {
    show: boolean;
    title: string | null;
    message: string | null;
    type: 'success' | 'error' | 'warning';
    refresh: boolean | null;
  };
  showExpiredSessionModal: boolean;
}

// Estado inicial de `modalAlert`
const initialState: ModalAlertState = {
  options: { show: false, title: null, message: null, type: 'success', refresh: false },
  showExpiredSessionModal: false,
};

const modalAlertSlice = createSlice({
  name: 'modalAlert',
  initialState,
  reducers: {
    showLoading(state, action: PayloadAction<ModalAlertState['options']>) {
      state.options = action.payload;
    },
    showExpiredSession(state, action: PayloadAction<boolean>) {
      state.showExpiredSessionModal = action.payload;
    },
    hideModal(state) {
      state.options.show = false;
    },
    resetModal(state) {
      return initialState;
    },
  },
});

export const { showLoading, showExpiredSession, hideModal, resetModal } =
  modalAlertSlice.actions;
export default modalAlertSlice.reducer;

// Thunks para realizar acciones relacionadas con el modal
export const showSuccessModal =
  (title: string | null = null, message: string | null = null, refresh: boolean = false) =>
  (dispatch: AppDispatch) => {
    dispatch(showLoading({ show: true, type: 'success', title, message, refresh }));
  };

export const showErrorModal =
  (title: string | null = null, message: string | null = null, refresh: boolean = false) =>
  (dispatch: AppDispatch) => {
    dispatch(showLoading({ show: true, type: 'error', title, message, refresh }));
  };

export const showWarningModal =
  (title: string | null = null, message: string | null = null, refresh: boolean = false) =>
  (dispatch: AppDispatch) => {
    dispatch(showLoading({ show: true, type: 'warning', title, message, refresh }));
  };

export const showExpiredSessionModal = () => (dispatch: AppDispatch) => {
  dispatch(showExpiredSession(true));
};

export const hideModalThunk =
  () => (dispatch: AppDispatch, getState: () => RootState) => {
    dispatch(hideModal());
    setTimeout(() => {
      dispatch(resetModal());
    }, 1000);
  };
